"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mouth = void 0;
exports.mouth = {
    frown: (color) => `
    <path d="M-5 41c3.21-7.957 15.107-24.767 37.007-28.348 21.9-3.58 33.12 8.455 35.993 14.92" stroke="${color}" stroke-width="4"/>
  `,
    laughing: (color) => `
    <path d="M62.807 25.177a34 34 0 001.113-11.846c-.17-2.068-2.284-3.22-4.075-2.513-4.229 1.666-18.218 6.965-28.082 8.322-10.823 1.49-27.213-.319-31.957-.908-1.93-.24-3.649 1.418-3.316 3.433a34 34 0 0066.317 3.512z" fill="${color}" stroke="${color}" stroke-width="4"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M51.83 39.553a31.997 31.997 0 01-37.208 4.612c2.854-6.95 9.273-12.2 17.26-13.188 7.983-.988 15.485 2.536 19.947 8.576z"/>
  `,
    nervous: (color) => `
    <rect x="-6.752" y="17.471" width="70" height="24" rx="4" transform="rotate(-4 -6.752 17.47)" fill="${color}"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M56.821 13.025L-.496 17.033l1.84 7.005a6 6 0 006.222 4.46 6 6 0 00-5.54 5.284l-.848 7.193 57.317-4.008-1.84-7.005a6 6 0 00-6.221-4.46 6 6 0 005.54-5.284l.847-7.193z" fill="#fff"/>
    <path d="M-1.933 15.845c-3.656-.263-6.744 2.765-6.486 6.451l1.018 14.57c.258 3.686 3.737 6.254 7.322 5.485 6.944-1.49 20.221-4.134 29.816-4.805 9.596-.671 23.112.099 30.196.608 3.656.264 6.744-2.764 6.486-6.45L65.4 17.134c-.257-3.686-3.737-6.254-7.32-5.485-6.945 1.49-20.222 4.134-29.818 4.805-9.595.671-23.111-.099-30.195-.609z" stroke="${color}" stroke-width="4"/>
  `,
    pucker: (color) => `
    <path d="M26 16.697c4.167-2.334 21-5.3 21 1.5 0 8.5-11.5 8-11.5 8s13.045-3.162 10.5 6c-2.5 9-9.5 5.5-11.5 4.5" stroke="${color}" stroke-width="4"/>
  `,
    sad: (color) => `
    <path d="M13 46c1.715-7.957 8.07-24.767 19.77-28.348 11.7-3.58 17.695 8.455 19.23 14.92" stroke="${color}" stroke-width="4"/>
  `,
    smile: (color) => `
    <path d="M-.5 17.5c2.5 17 31 25 57 5.5" stroke="${color}" stroke-width="4"/>
  `,
    smirk: (color) => `
    <path d="M10 24.165c4.941 6.447 12.428 13.589 23.977 11.96 11.549-1.629 16.687-9.595 15.172-16.047" stroke="${color}" stroke-width="4"/>
  `,
    surprised: (color) => `
    <path d="M36.047 54.891c10.837-1.96 17.186-13.936 14.978-26.137S38.673 7.562 27.836 9.524C17 11.483 10.65 23.46 12.86 35.66c2.208 12.2 12.35 21.192 23.188 19.23z" fill="${color}" stroke="${color}" stroke-width="3.591"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.14 42.653c2.784-5.208 8.143-9.242 14.803-10.447C38.603 31 45.035 32.9 49.467 36.8c-1.082 8.29-6.37 14.989-13.739 16.322-7.369 1.334-14.669-3.087-18.587-10.47z"/>
  `,
};
